import { useIframeDialogStore } from 'widgets/iframe-dialog/model/iframe-dialog-store';

export const ModalForm = () => {
  const { link } = useIframeDialogStore();
  return <iframe title="map" width={'100%'} height={'100%'} src={link} />;
};
